/* CUSTOMDO PDP (1c/2a/2b) — progressive enhancement, kein Eingriff in App-Interna.
   Module: [1] Teeinblue-Detection (steuert Badge/Warnung/Picker-Sichtbarkeit)
           [2] Zahlen-Picker 1–99 für Alters-Varianten (Duplo-Box u. ä.)
           [3] Sticky-ATC-Bar + Preis-/Label-Sync (inkl. T&B-Summenpreis)
           [4] Prüf-Checkbox vor ATC (nur Konfigurator-Produkte)
           [5] Stationen-Akkordeon um T&B-Feldgruppen (defensiv, nur bei klarer Struktur)
   Not-Aus für [5]: localStorage.setItem('cdxWizardOff','1') oder window.cdxWizardOff() */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var state = { data: null, numPicker: null, atcExtra: '', tbPrice: '' };

  function money(txt) { return (txt || '').replace(/\s+/g, ' ').trim(); }
  function qs(s, c) { return (c || doc).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  /* ---------- [1] Teeinblue-Detection ---------- */
  function watchTeeinblue() {
    var mount = qs('#teeinblue-form');
    if (!mount) return;
    function check() {
      var mounted = mount.children.length > 0 && mount.offsetHeight > 40;
      root.classList.toggle('cdx-has-tb', mounted);
      if (mounted) { onTbMounted(mount); return true; }
      return false;
    }
    if (check()) return;
    var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
    mo.observe(mount, { childList: true, subtree: true });
    setTimeout(check, 2500); setTimeout(check, 6000);
  }

  var tbInitDone = false;
  function onTbMounted(mount) {
    if (tbInitDone) return; tbInitDone = true;
    initCheckGate();
    watchTbPrice(mount);
    // Stationen-Akkordeon + Farb-Tagging übernimmt customdo-tb-accordion.js (Handoff V3)
  }

  /* ---------- [2] Zahlen-Picker (2b) ---------- */
  function parseProduct() {
    var el = qs('#cdx-product-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function agePattern(v) { var m = /^(\d{1,3})\.\s*/.exec(v.option1 || ''); return m ? parseInt(m[1], 10) : null; }

  /* ---------- Echte Varianten schuetzen (Testbefund 01.08.2026) ----------
     Schwerster Einzelfehler des Nachtests: Bei der Gedenktafel sind
     "Gedenktafel Katze" und "Gedenktafel Hund" ECHTE Shopify-Varianten, Katze ist
     die Standardvariante. Unsere Regel blendet Shopifys Variantenauswahl aus,
     sobald ein Konfigurator erkannt wird — der Kunde konnte "Hund" also gar nicht
     waehlen und hat zwangslaeufig eine Katze bestellt.

     Die Regel war gegen doppelte Auswahlen gedacht. Eine doppelte Auswahl ist ein
     Schoenheitsfehler, eine falsch bestellte Ware nicht. Deshalb: ausgeblendet wird
     nur noch, wenn es GAR NICHTS zu waehlen gibt — also genau eine echte Variante.
     Reine Preisanpassungs-Varianten ("+ 7.00 €") zaehlen nicht als Auswahl; sie
     dienen Teeinblue zur Aufpreisverrechnung und tauchen im Picker ohnehin nicht
     als sinnvolle Option auf. */
  function markRealVariants() {
    var data = parseProduct();
    if (!data || !data.variants) return;
    var real = data.variants.filter(function (v) {
      return !/^\s*[+-]\s*[\d.,]+\s*(€|EUR)?\s*$/.test(v.option1 || v.title || '');
    });
    if (real.length > 1) root.classList.add('cdx-multivariant');
  }

  function initNumPicker() {
    if (qs('.cdx-numpick')) return; // idempotent
    var data = state.data;
    if (!data || !data.variants || data.variants.length < 10) return;
    var matched = data.variants.filter(function (v) { return agePattern(v) !== null; });
    if (matched.length / data.variants.length < 0.9) return;

    var byAge = {}; var min = 999, max = 0;
    matched.forEach(function (v) { var a = agePattern(v); byAge[a] = v; if (a < min) min = a; if (a > max) max = a; });

    var anchor = qs('variant-selects') || qs('.product-form__input--quantity') || qs('.product-form');
    if (!anchor) return;
    root.classList.add('cdx-numpick');

    var wrap = doc.createElement('div');
    wrap.className = 'cdx-numpick';
    wrap.innerHTML =
      '<div class="cdx-numpick-label">Welcher Geburtstag?</div>' +
      '<div class="cdx-numpick-row">' +
        '<button type="button" class="cdx-numpick-btn" data-d="-1" aria-label="Jahr weniger">−</button>' +
        '<div class="cdx-numpick-val"><span class="n">18</span><span class="suffix">.</span></div>' +
        '<button type="button" class="cdx-numpick-btn" data-d="1" aria-label="Jahr mehr">+</button>' +
      '</div>' +
      '<div class="cdx-numpick-chips"><span class="lbl">Beliebte Geburtstage:</span></div>' +
      '<div class="cdx-numpick-note" hidden>Diese Zahl ist leider nicht verfügbar.</div>';
    var chipsRow = qs('.cdx-numpick-chips', wrap);
    [1, 16, 18, 25, 30, 40, 50, 60, 70, 80].forEach(function (n) {
      if (!byAge[n]) return;
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'cdx-numpick-chip'; b.textContent = n + '.';
      b.addEventListener('click', function () { setAge(n); });
      chipsRow.appendChild(b);
    });
    anchor.parentNode.insertBefore(wrap, anchor);

    var valEl = qs('.cdx-numpick-val .n', wrap), noteEl = qs('.cdx-numpick-note', wrap);
    var current = null;

    function findVariantInputs() {
      return qsa('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]');
    }
    function setAge(n, dir) {
      n = Math.max(min, Math.min(max, n));
      // Lücken in der Altersreihe überspringen — Anzeige darf nie von der Variante abweichen
      if (!byAge[n]) {
        var step = dir || 1, m = n;
        while (m >= min && m <= max && !byAge[m]) m += step;
        if (!byAge[m]) { m = n; while (m >= min && m <= max && !byAge[m]) m -= step; }
        if (!byAge[m]) return;
        n = m;
      }
      var v = byAge[n];
      valEl.textContent = n;
      qsa('.cdx-numpick-chip', wrap).forEach(function (c) { c.classList.toggle('is-active', parseInt(c.textContent, 10) === n); });
      if (!v) { noteEl.hidden = false; return; }
      noteEl.hidden = v.available; current = { age: n, variant: v };
      // 1) Nativen Picker mitführen (Dawn-Pipeline: Preis/URL/Verfügbarkeit)
      var radio = qs('variant-selects input[type="radio"][value="' + CSS.escape(v.option1) + '"]');
      var select = qs('variant-selects select');
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      else if (select) { select.value = v.option1; select.dispatchEvent(new Event('change', { bubbles: true })); }
      else { findVariantInputs().forEach(function (i) { i.value = v.id; }); }
      // 2) Label & Sticky-Bar
      state.atcExtra = n + '. Geburtstag';
      syncAtc();
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.cdx-numpick-btn'); if (!b) return;
      var d = parseInt(b.getAttribute('data-d'), 10);
      setAge(parseInt(valEl.textContent, 10) + d, d);
    });

    // Startwert: aktuell gewählte Variante oder 18, sonst erste verfügbare
    var cur = findVariantInputs()[0];
    var startVariant = cur && data.variants.filter(function (v) { return String(v.id) === String(cur.value); })[0];
    var start = startVariant ? agePattern(startVariant) : (byAge[18] ? 18 : min);
    setAge(start || min);
    state.numPicker = { setAge: setAge, get: function () { return current; } };
  }

  /* ---------- [3] Sticky-Bar + Preis-Sync ---------- */
  var bar, submit, submitSpan, priceEl;
  function parseEuroCents(s) {
    s = String(s || '');
    // Tausenderpunkte tolerieren: "1.299,00" -> 129900
    var m = /(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})(?!\d)/.exec(s);
    if (m) return parseInt(m[1].replace(/\./g, ''), 10) * 100 + (+m[2]);
    m = /(\d+)\.(\d{2})(?!\d)/.exec(s);
    return m ? (+m[1]) * 100 + (+m[2]) : null;
  }
  function fmtCents(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function variantPriceCents(v) {
    if (!v) return null;
    if (typeof v.price === 'number' && isFinite(v.price)) return v.price;
    var n = parseInt(v.price, 10);
    if (isFinite(n) && /^\d+$/.test(String(v.price))) return n;
    return parseEuroCents(v.price_formatted);
  }
  function getPriceEl() {
    var scope = qs('.product__info-container') || doc;
    var sale = qs('.price--on-sale .price-item--sale, .price__sale .price-item--sale', scope);
    if (sale && sale.offsetParent !== null) return sale;
    return qs('.price__container .price-item--regular, .price .price-item--regular, .price .price-item', scope);
  }
  function baseCents() {
    var inp = qs('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]');
    if (state.data && inp) {
      var v = state.data.variants.filter(function (x) { return String(x.id) === String(inp.value); })[0];
      var c = variantPriceCents(v);
      if (c != null) return c;
    }
    if (state.data && state.data.variants && state.data.variants.length) {
      var c0 = variantPriceCents(state.data.variants[0]);
      if (c0 != null) return c0;
    }
    // NIE live aus dem Element lesen, das syncAtc selbst beschreibt (Feedback-Schleife) —
    // stattdessen der einmalig VOR dem ersten Schreiben geparste Startwert:
    return state.fallbackBase != null ? state.fallbackBase : null;
  }
  /* F1: Aufpreise „(+ 9,00 €)" der GEWÄHLTEN T&B-Optionen summieren.
     Klassen-Token mit Wortgrenze (nicht 'unselected'/'interactive'), tiefste Treffer,
     alle Beträge je Knoten (matchAll-Äquivalent). */
  var SEL_TOKEN = /(^|[\s_-])(is[-_])?(selected|active|checked|current)([\s_-]|$)/i;
  var PRICE_G = /\(\s*\+\s*(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})\s*€\s*\)/g;
  function tbSurcharge() {
    var mount = qs('#teeinblue-form');
    if (!mount) return { sum: 0, found: false };
    var cands = qsa('*', mount).filter(function (el) {
      if (el.closest('.cd-station-head')) return false;
      if (SEL_TOKEN.test(String(el.className))) return true;
      if (el.getAttribute && (el.getAttribute('aria-selected') === 'true' || el.getAttribute('aria-checked') === 'true')) return true;
      return false;
    });
    qsa('input:checked', mount).forEach(function (i) {
      var row = i.closest('label') || i.parentElement || i;
      // Preis steht ggf. im Geschwister-Element: eine Ebene höher, wenn dort genau EIN Betrag steht
      PRICE_G.lastIndex = 0;
      if (row.parentElement && !PRICE_G.test(row.textContent || '')) {
        var p = row.parentElement;
        var m = (p.textContent || '').match(PRICE_G) || [];
        if (m.length === 1 && p.querySelectorAll('input').length <= 1) row = p;
      }
      if (cands.indexOf(row) === -1) cands.push(row);
    });
    // nur TIEFSTE Treffer behalten (ein "aktiver" Schritt-Wrapper enthält sonst
    // auch die Texte der NICHT gewählten Optionen)
    cands = cands.filter(function (el) {
      return !cands.some(function (o) { return o !== el && el.contains(o); });
    });
    var sum = 0, found = false;
    cands.forEach(function (el) {
      var txt = el.textContent || '', m;
      PRICE_G.lastIndex = 0;
      while ((m = PRICE_G.exec(txt))) {
        sum += parseInt(m[1].replace(/\./g, ''), 10) * 100 + (+m[2]);
        found = true;
      }
    });
    return { sum: sum, found: found };
  }
  function currentPrice() {
    if (root.classList.contains('cdx-has-tb')) {
      var b = baseCents();
      if (b != null) {
        var s = tbSurcharge();
        return fmtCents(b + s.sum);
      }
    }
    return priceEl ? money(priceEl.textContent) : '';
  }
  function syncAtc() {
    priceEl = getPriceEl(); // Dawn ersetzt das Preis-DOM bei Variantenwechsel — immer neu auflösen
    var p = currentPrice();
    // F1: Kopfpreis mitführen (Basis kommt aus Varianten-JSON, nie aus diesem Element → keine Schleife)
    if (p && priceEl && root.classList.contains('cdx-has-tb') && money(priceEl.textContent) !== p) priceEl.textContent = p;
    if (bar) {
      if (p) qs('.p', bar).textContent = p;
      var t = qs('.t', bar);
      if (t && state.atcExtra) t.textContent = (state.data ? state.data.title : '') + ' · ' + state.atcExtra;
    }
    if (submitSpan && submit && !submit.disabled) {
      var label = 'In den Warenkorb';
      if (state.atcExtra) label += ' — ' + state.atcExtra + (p ? ' · ' + p : '');
      else if (p) label += ' — ' + p;
      submitSpan.textContent = label;
    }
  }
  function initSticky() {
    if (qs('.cdx-stickybar')) return; // idempotent (doppelte Script-Ausführung)
    var info = qs('.product__info-container');
    submit = qs('.product-form__submit');
    if (!info || !submit) return;
    submitSpan = submit.querySelector('span');
    priceEl = getPriceEl();
    // Fallback-Basis EINMAL parsen, bevor irgendetwas geschrieben wird (Schleifen-Schutz)
    state.fallbackBase = priceEl ? parseEuroCents(priceEl.textContent) : null;
    var titleEl = qs('.product__title h1, .product__title .h1');
    bar = doc.createElement('div');
    bar.className = 'cdx-stickybar';
    bar.innerHTML = '<div class="in"><span class="t"></span><span class="p"></span>' +
      '<button type="button" class="b">In den Warenkorb</button></div>';
    doc.body.appendChild(bar);
    qs('.t', bar).textContent = titleEl ? titleEl.textContent.trim() : (doc.title || '');
    qs('.b', bar).addEventListener('click', function () {
      submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { try { submit.click(); } catch (e) {} }, 380);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(submit);
    } else {
      // Fallback ohne IO: ab 60 % Scroll zeigen
      var onScroll = function () { bar.classList.toggle('show', window.scrollY > window.innerHeight * 0.6); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    // stabilen Vorfahren beobachten — Dawn ersetzt .price-Innenleben bei Variantenwechsel
    var priceHost = qs('.product__info-container') || qs('.price');
    if (priceHost) {
      var pt = null;
      new MutationObserver(function () { clearTimeout(pt); pt = setTimeout(syncAtc, 120); })
        .observe(priceHost, { childList: true, subtree: true, characterData: true });
    }
    syncAtc();
  }
  // F1: bei jeder Auswahl-Änderung im Widget Preis neu rechnen (Klick/Change + Re-Render)
  function watchTbPrice(mount) {
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(syncAtc, 150); }
    mount.addEventListener('click', later, true);
    mount.addEventListener('change', later, true);
    new MutationObserver(later).observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    syncAtc();
  }

  /* ---------- [4] Prüf-Checkbox (nur Konfigurator-Produkte) ---------- */
  function initCheckGate() {
    if (qs('.cdx-checkgate')) return;
    var warn = qs('.cdx-pdp-warn');
    if (!warn || !submit) return;
    var gate = doc.createElement('label');
    gate.className = 'cdx-checkgate';
    gate.innerHTML = '<input type="checkbox" class="cdx-checkgate-box"> <span>Ich habe alle Angaben (Namen, Datum, Schreibweise) in der Vorschau geprüft.</span>';
    warn.parentNode.insertBefore(gate, warn.nextSibling);
    var box = qs('input', gate);
    function apply() {
      var ok = box.checked;
      submit.classList.toggle('cdx-atc-locked', !ok);
      submit.toggleAttribute('data-cdx-locked', !ok);
      root.classList.toggle('cdx-gate-locked', !ok); // sperrt auch Express-Checkout (CSS)
    }
    function block(e) {
      if (!submit.hasAttribute('data-cdx-locked')) return;
      e.preventDefault(); e.stopPropagation();
      gate.classList.add('shake'); setTimeout(function () { gate.classList.remove('shake'); }, 500);
      gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    submit.addEventListener('click', block, true);
    // Enter im Mengenfeld submittet das Formular ohne Klick — auch das abfangen
    var form = submit.closest('form');
    if (form) form.addEventListener('submit', block, true);
    box.addEventListener('change', apply);
    apply();
  }

  /* ---------- F3: Express-Checkout unter Trennzeile ---------- */
  function initExpressDivider() {
    var payBtn = qs('.shopify-payment-button');
    if (!payBtn || qs('.cdx-express-div')) return;
    var d = doc.createElement('div');
    d.className = 'cdx-express-div';
    d.textContent = 'Express-Checkout';
    payBtn.parentNode.insertBefore(d, payBtn);
  }

  /* ---------- Rohes Markdown in der Beschreibung abfangen ----------
     Ein Produkt (Weihnachtskugel) hat **Sternchen** statt Fettschrift in der
     Shopify-Beschreibung stehen — der Kunde liest dann woertlich "**Material**".
     Sauber waere die Korrektur im Produkttext; bis dahin faengt das Theme es ab.
     Es werden ausschliesslich TEXTKNOTEN angefasst, vorhandenes HTML bleibt
     unberuehrt, und ohne Treffer passiert nichts. */
  function fixMarkdownBold(box) {
    if (!box) return;
    var walker = doc.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var hits = [], n;
    while ((n = walker.nextNode())) {
      if (/\*\*[^*\n]{1,120}\*\*/.test(n.textContent)) hits.push(n);
    }
    hits.forEach(function (node) {
      var frag = doc.createDocumentFragment();
      var rest = node.textContent, m;
      var re = /\*\*([^*\n]{1,120})\*\*/;
      while ((m = re.exec(rest))) {
        if (m.index) frag.appendChild(doc.createTextNode(rest.slice(0, m.index)));
        var b = doc.createElement('strong');
        b.textContent = m[1];
        frag.appendChild(b);
        rest = rest.slice(m.index + m[0].length);
      }
      if (rest) frag.appendChild(doc.createTextNode(rest));
      node.parentNode.replaceChild(frag, node);
    });
  }

  /* ---------- F5: Beschreibung strukturieren (Emoji-Absätze → fette Zwischenüberschriften) ---------- */
  function restructureDescription() {
    var box = qs('.product__description');
    if (!box) return;
    var re;
    try { re = new RegExp('^[\\s\\u{FE0F}\\u{200D}\\p{Extended_Pictographic}]+', 'u'); } catch (e) { return; }
    qsa('p', box).forEach(function (el) {
      if (!re.test((el.textContent || ''))) return;
      // führende Emojis aus den ersten Textknoten entfernen
      var n = el.firstChild;
      while (n) {
        if (n.nodeType === 3) {
          var s = n.textContent.replace(re, '');
          n.textContent = s;
          if (s.trim() !== '') break;
          var nx = n.nextSibling; el.removeChild(n); n = nx; continue;
        }
        if (n.nodeType === 1) {
          var t = (n.textContent || '').trim();
          if (t.length <= 3 && re.test(t)) { var nx2 = n.nextSibling; el.removeChild(n); n = nx2; continue; }
          break;
        }
        n = n.nextSibling;
      }
      // <strong> am Absatzanfang → eigene fette Zwischenüberschrift
      var first = el.firstElementChild;
      if (first && first.tagName === 'STRONG') {
        var before = '';
        for (var c = el.firstChild; c && c !== first; c = c.nextSibling) before += c.textContent || '';
        if (before.trim() === '') {
          var h = doc.createElement('p');
          h.className = 'cdx-desc-h';
          h.textContent = (first.textContent || '').replace(/[\s:–—-]+$/, '');
          el.parentNode.insertBefore(h, el);
          first.parentNode.removeChild(first);
          if (el.firstChild && el.firstChild.nodeType === 3) el.firstChild.textContent = el.firstChild.textContent.replace(/^[\s:–—-]+/, '');
          if (!(el.textContent || '').trim()) el.parentNode.removeChild(el);
        }
      }
    });
  }

  /* ---------- boot ---------- */
  function init() {
    if (!root.classList.contains('cdx-pdp')) return;
    state.data = parseProduct();
    /* Muss VOR der T&B-Erkennung laufen: Sobald cdx-has-tb gesetzt wird, greift die
       Ausblend-Regel fuer den Varianten-Picker. cdx-multivariant muss dann schon
       stehen, sonst waere die Auswahl fuer einen Moment verschwunden. */
    markRealVariants();
    initSticky();
    initNumPicker();
    initExpressDivider();
    try { restructureDescription(); } catch (e) {}
    try { fixMarkdownBold(qs('.product__description')); } catch (e) {}
    watchTeeinblue();
  }
  if (doc.readyState !== 'loading') init();
  else doc.addEventListener('DOMContentLoaded', init);
})();
